import { render, staticRenderFns } from "./vip-targeted.vue?vue&type=template&id=7a1d6952&scoped=true&"
import script from "./vip-targeted.vue?vue&type=script&lang=js&"
export * from "./vip-targeted.vue?vue&type=script&lang=js&"
import style0 from "./vip-targeted.vue?vue&type=style&index=0&id=7a1d6952&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1d6952",
  null
  
)

export default component.exports